import { gql } from "@apollo/client";
import { VerificationStatus } from "../../shared/interfaces/iform";

export const START_VERIFICATION_MUTATION = gql`
  mutation StartVerification($startVerificationInput: StartVerificationInput!) {
    startVerification(startVerificationInput: $startVerificationInput) {
      id
      plaidClientId
      linkToken
      message
      status
      createdAt
    }
  }
`;

export const FAIL_VERIFICATION_MUTATION = gql`
  mutation FailVerification($failVerificationInput: FailVerificationInput!) {
    failVerification(failVerificationInput: $failVerificationInput) {
      id
    }
  }
`;

export const COMPLETE_VERIFICATION_MUTATION = gql`
  mutation CompleteVerification(
    $completeVerificationInput: CompleteVerificationInput!
  ) {
    completeVerification(
      completeVerificationInput: $completeVerificationInput
    ) {
      id
      status
    }
  }
`;

export type FailVerificationVariables = {
  failVerificationInput: {
    id: string;
    errorType?: string;
    errorCode?: string;
    errorMessage: string;
    linkSessionId?: string;
  };
};

export type completeVerificationResponse = {
  completeVerification: {
    id: string;
    status: VerificationStatus;
  };
};

export type CompleteVerificationVariables = {
  completeVerificationInput: {
    id: string;
    publicToken: string;
    linkSessionId: string;
  };
};

export type StartVerificationResponse = {
  startVerification: {
    id: string;
    linkToken?: string;
    plaidClientId: string;
    message: string;
    status: string;
    createdAt: string;
  };
};

export type StartVerificationVariables = {
  startVerificationInput: {
    template: "selfApply" | "advisorPrefill";
    email: string;
    name: string;
    ssn: string;
    lastName: string;
    dateOfBirth?: string;
    phoneNumber: string;
  };
};
